import { useWhiteLabel } from "src/hooks/useWhiteLabel";

export function MessagesBuilderImg() {
  let color1 = '#0000c8';
  let color2 = '#3e3eff';
  let color3 = '#1616ff';
  let color4 = '#0000e2';
  let color5 = '#000052';
  const whitelabel = useWhiteLabel();
  if (whitelabel.isWl) {
    if (whitelabel.cssPathWl.includes('chatshub')) {
      color1 = '#FF7038';
      color2 = '#fa8e64';
      color3 = '#ff6445';
      color4 = '#EE4B2B';
      color5 = '#994321';
    }
    if (whitelabel.cssPathWl.includes('auvo')) {
      color1 = '#6d26c2';
      color2 = '#7b3bc8';
      color3 = '#571e9b';
      color4 = '#41186a';
      color5 = '#2b0f4d';
    }
    if (whitelabel.cssPathWl.includes('nectarcrm')) {
      color1 = '#ffd55b';
      color2 = '#ffe086';
      color3 = '#f3c641';
      color4 = '#fec10d';
      color5 = '#e5ae0c';
    }
    if (whitelabel.cssPathWl.includes('aqbank')) {
      color1 = '#D76F21';
      color2 = '#D76F21';
      color3 = '#D76F21';
      color4 = '#D76F21';
      color5 = '#3F3F3E';
    }
    if (whitelabel.cssPathWl.includes('usecredituz')) {
      color1 = '#000000';
      color2 = '#000000';
      color3 = '#000000';
      color4 = '#000000';
      color5 = '#FAD82E';
    }
  }
  return (
    <svg
      className="img-fluid"
      width="394"
      height="370"
      viewBox="0 0 394 370"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M342.344 267.99H183.94C178.786 267.99 174.647 272.156 174.647 277.257V343.057C174.647 348.196 178.825 352.324 183.94 352.324H200.377C199.44 359.565 198.191 369.961 198.855 369.961C199.597 369.961 207.562 359.02 212.403 352.324H342.344C347.498 352.324 351.637 348.157 351.637 343.057V277.257C351.637 272.156 347.498 267.99 342.344 267.99Z"
        fill={`${color1}`}
      />
      <path
        d="M349.919 250.508H191.514C186.36 250.508 182.222 254.674 182.222 259.775V325.575C182.222 330.715 186.399 334.842 191.514 334.842H207.952C207.015 342.084 205.766 352.479 206.429 352.479C207.171 352.479 215.136 341.538 219.978 334.842H349.919C355.073 334.842 359.211 330.676 359.211 325.575V259.775C359.211 254.674 355.033 250.508 349.919 250.508Z"
        fill={`${color3}`}
      />
      <path
        d="M229.364 309.384C238.467 300.307 238.467 285.589 229.364 276.512C220.262 267.435 205.503 267.435 196.4 276.512C187.297 285.589 187.297 300.307 196.4 309.384C205.503 318.461 220.262 318.461 229.364 309.384Z"
        fill="white"
      />
      <path
        d="M216.542 304.667H209.709V311.481H216.542V304.667Z"
        fill={`${color2}`}
      />
      <path
        d="M216.581 308.755V304.667H209.748V308.132C211.193 308.911 213.379 309.378 216.581 308.755Z"
        fill={`${color4}`}
      />
      <path
        d="M227.357 292.441C226.655 292.091 225.796 292.169 225.054 292.519C225.327 285.783 219.783 280.138 212.872 280.371C205.922 280.138 200.416 285.783 200.69 292.519C199.948 292.13 199.128 292.091 198.386 292.441C197.02 293.103 196.59 295.05 197.449 296.763C198.308 298.476 200.104 299.294 201.471 298.632C201.666 298.554 201.822 298.437 201.978 298.282C202.759 303.849 207.445 308.015 212.911 307.937C218.377 308.015 223.023 303.849 223.843 298.282C223.999 298.437 224.156 298.554 224.351 298.632C225.717 299.294 227.514 298.476 228.373 296.763C229.153 295.05 228.763 293.103 227.357 292.441Z"
        fill={`${color2}`}
      />
      <path
        d="M204.555 277.724C204.555 277.724 207.991 274.804 215.8 275.31C223.609 275.777 225.093 279.826 225.561 285.667L225.093 292.558C225.093 292.558 223.062 290.495 220.407 284.693C220.407 284.693 216.034 289.599 214.121 289.015C212.208 288.431 214.824 284.927 214.824 284.927C214.824 284.927 205.922 292.558 200.651 292.558C200.651 292.558 197.878 283.603 201.783 280.333C201.783 280.333 198.855 280.488 198.698 279.904C198.542 279.32 200.104 278.464 202.915 278.775C202.915 278.775 200.885 274.843 202.017 274.453C203.189 274.025 204.555 277.724 204.555 277.724Z"
        fill={`${color5}`}
      />
      <path
        d="M217.362 300.384C217.05 301.747 215.527 302.798 213.614 302.837C211.7 302.876 210.1 301.941 209.709 300.618L217.362 300.384Z"
        fill="white"
      />
      <path
        d="M336.175 273.519H245.162C244.654 273.519 244.225 273.091 244.225 272.584V270.365C244.225 269.859 244.654 269.431 245.162 269.431H336.175C336.682 269.431 337.112 269.859 337.112 270.365V272.584C337.073 273.13 336.682 273.519 336.175 273.519Z"
        fill="white"
      />
      <path
        d="M265.231 284.187H245.123C244.615 284.187 244.186 283.759 244.186 283.253V281.033C244.186 280.527 244.615 280.099 245.123 280.099H265.231C265.738 280.099 266.168 280.527 266.168 281.033V283.253C266.168 283.759 265.738 284.187 265.231 284.187Z"
        fill="white"
      />
      <path
        d="M336.175 284.187H275.343C274.836 284.187 274.406 283.759 274.406 283.253V281.033C274.406 280.527 274.836 280.099 275.343 280.099H336.175C336.682 280.099 337.112 280.527 337.112 281.033V283.253C337.073 283.759 336.682 284.187 336.175 284.187Z"
        fill="white"
      />
      <path
        d="M291.273 294.855H245.162C244.654 294.855 244.225 294.427 244.225 293.921V291.702C244.225 291.195 244.654 290.767 245.162 290.767H291.273C291.781 290.767 292.211 291.195 292.211 291.702V293.921C292.211 294.427 291.781 294.855 291.273 294.855Z"
        fill="white"
      />
      <path
        d="M336.175 294.855H300.137C299.629 294.855 299.2 294.427 299.2 293.921V291.702C299.2 291.195 299.629 290.767 300.137 290.767H336.175C336.682 290.767 337.112 291.195 337.112 291.702V293.921C337.073 294.427 336.682 294.855 336.175 294.855Z"
        fill="white"
      />
      <path
        d="M336.175 305.524H245.162C244.654 305.524 244.225 305.095 244.225 304.589V302.37C244.225 301.864 244.654 301.435 245.162 301.435H336.175C336.682 301.435 337.112 301.864 337.112 302.37V304.589C337.073 305.095 336.682 305.524 336.175 305.524Z"
        fill="white"
      />
      <path
        opacity="0.3"
        d="M228.06 118.635H46.6584C40.4112 118.635 35.2964 123.697 35.2964 129.965V204.604C35.2964 210.833 40.3722 215.934 46.6584 215.934H189.484C195.263 223.993 205.727 238.399 206.664 238.399C207.523 238.399 205.844 224.811 204.672 215.934H228.06C234.307 215.934 239.422 210.872 239.422 204.604V129.926C239.422 123.697 234.346 118.635 228.06 118.635Z"
        fill={`${color1}`}
      />
      <path
        d="M220.563 99.2455H39.1618C32.9147 99.2455 27.7998 104.307 27.7998 110.576V185.214C27.7998 191.444 32.8756 196.544 39.1618 196.544H181.987C187.766 204.604 198.23 219.01 199.167 219.01C200.026 219.01 198.347 205.421 197.176 196.544H220.563C226.811 196.544 231.925 191.483 231.925 185.214V110.576C231.925 104.307 226.85 99.2455 220.563 99.2455Z"
        fill={`${color4}`}
      />
      <path
        d="M77.7349 174.027C92.2366 167.974 99.079 151.361 93.0178 136.92C86.9567 122.479 70.2872 115.678 55.7855 121.731C41.2838 127.783 34.4414 144.397 40.5025 158.838C46.5637 173.279 63.2332 180.079 77.7349 174.027Z"
        fill="white"
      />
      <path
        d="M51.9295 148.654C51.9295 148.654 49.1183 137.129 55.8339 132.808C62.5496 128.486 69.7339 127.512 74.6144 130.004C81.4082 133.469 84.2194 142.775 82.0329 147.953L64.0333 143.359L51.9295 148.654Z"
        fill={`${color5}`}
      />
      <path
        d="M71.2567 162.204H62.9011V170.536H71.2567V162.204Z"
        fill={`${color2}`}
      />
      <path
        d="M71.2567 167.187V162.204H62.9011V166.447C64.6972 167.382 67.3522 167.927 71.2567 167.187Z"
        fill={`${color4}`}
      />
      <path
        d="M84.4147 147.291C83.5557 146.863 82.5405 146.941 81.6034 147.408C81.9158 139.193 75.2001 132.301 66.7274 132.613C58.2547 132.34 51.539 139.232 51.8514 147.408C50.9534 146.941 49.9382 146.863 49.0402 147.291C47.3612 148.109 46.8537 150.484 47.8688 152.548C48.884 154.611 51.1095 155.662 52.7494 154.845C52.9837 154.728 53.1789 154.572 53.3741 154.416C54.3502 161.191 60.0117 166.292 66.6884 166.175C73.365 166.253 79.0265 161.191 80.0026 154.416C80.1978 154.572 80.3931 154.728 80.6273 154.845C82.3063 155.662 84.4928 154.65 85.5079 152.548C86.6012 150.484 86.0936 148.109 84.4147 147.291Z"
        fill={`${color2}`}
      />
      <path
        d="M72.2328 156.986C71.8814 158.621 69.9682 159.906 67.6646 159.984C65.3609 160.062 63.3697 158.894 62.9011 157.259L72.2328 156.986Z"
        fill="white"
      />
      <path
        d="M51.8904 147.408C51.8904 147.408 62.8229 144.099 67.5863 138.609C67.5863 138.609 66.2198 145.267 65.2046 146.318C65.517 146.513 76.1371 141.373 77.5427 136.662C78.9874 131.912 66.6883 130.199 66.6883 130.199C66.6883 130.199 62.4715 131.99 62.2762 132.107C62.081 132.224 58.1375 132.691 57.669 133.664C57.0833 134.988 54.3111 135.105 54.3111 135.105L52.5541 138.765L51.3047 142.619L51.8904 147.408Z"
        fill={`${color5}`}
      />
      <path
        d="M42.9102 132.379C45.3309 133.353 48.1031 133.781 50.9924 132.924C57.3567 130.978 59.8946 131.717 60.7536 132.224C61.2612 132.496 61.8859 132.613 62.4325 132.457C63.0572 132.262 63.6429 131.678 63.4477 130.238C63.4477 130.238 63.6819 124.203 58.489 120.738C52.0466 122.684 46.5413 126.889 42.9102 132.379Z"
        fill={`${color5}`}
      />
      <path
        d="M56.6539 131.99C56.4586 131.756 56.5367 131.367 56.771 131.211C57.8252 130.51 60.5583 128.953 63.8771 128.758C64.1895 128.758 64.4628 128.992 64.4628 129.303C64.4628 129.576 64.2285 129.81 63.9552 129.848C60.9488 130.004 58.3718 131.484 57.3957 132.107C57.1224 132.301 56.81 132.224 56.6539 131.99Z"
        fill={`${color4}`}
      />
      <path
        d="M137.711 128.369H101.829C101.204 128.369 100.696 127.863 100.696 127.24V124.592C100.696 123.969 101.204 123.463 101.829 123.463H137.711C138.335 123.463 138.843 123.969 138.843 124.592V127.279C138.843 127.902 138.335 128.369 137.711 128.369Z"
        fill="white"
      />
      <path
        d="M125.373 141.412H101.868C101.243 141.412 100.735 140.906 100.735 140.283V137.597C100.735 136.974 101.243 136.467 101.868 136.467H125.373C125.997 136.467 126.505 136.974 126.505 137.597V140.283C126.466 140.906 125.997 141.412 125.373 141.412Z"
        fill="white"
      />
      <path
        d="M161.489 141.412H132.049C131.424 141.412 130.917 140.906 130.917 140.283V137.597C130.917 136.974 131.424 136.467 132.049 136.467H161.489C162.113 136.467 162.621 136.974 162.621 137.597V140.283C162.582 140.906 162.113 141.412 161.489 141.412Z"
        fill="white"
      />
      <path
        d="M208.616 128.369H146.3C145.676 128.369 145.168 127.863 145.168 127.24V124.592C145.168 123.969 145.676 123.463 146.3 123.463H208.616C209.241 123.463 209.748 123.969 209.748 124.592V127.279C209.748 127.902 209.241 128.369 208.616 128.369Z"
        fill="white"
      />
      <path
        d="M208.616 166.876H101.868C101.243 166.876 100.735 166.37 100.735 165.747V163.06C100.735 162.437 101.243 161.931 101.868 161.931H208.616C209.241 161.931 209.748 162.437 209.748 163.06V165.747C209.748 166.37 209.241 166.876 208.616 166.876Z"
        fill="white"
      />
      <path
        d="M155.945 154.416H101.868C101.243 154.416 100.735 153.91 100.735 153.287V150.601C100.735 149.978 101.243 149.472 101.868 149.472H155.945C156.569 149.472 157.077 149.978 157.077 150.601V153.287C157.038 153.91 156.53 154.416 155.945 154.416Z"
        fill="white"
      />
      <path
        d="M208.616 154.416H166.408C165.784 154.416 165.276 153.91 165.276 153.287V150.601C165.276 149.978 165.784 149.472 166.408 149.472H208.616C209.24 149.472 209.748 149.978 209.748 150.601V153.287C209.748 153.91 209.24 154.416 208.616 154.416Z"
        fill="white"
      />
      <path
        d="M209.045 17.8712L212.833 46.2938L192.607 31.5374L130.604 0L178.512 4.36073C178.512 4.36073 202.915 10.2789 204.243 11.4858C205.609 12.6928 209.045 17.8712 209.045 17.8712Z"
        fill={`${color3}`}
      />
      <path
        d="M230.247 0.739766L130.604 0L209.045 17.8712L230.247 0.739766Z"
        fill={`${color4}`}
      />
      <path
        d="M176.99 46.4885L203.11 25.5803L130.604 0L176.99 46.4885Z"
        fill={`${color4}`}
      />
      <path
        d="M332.27 171.47L330.943 169.523C332.973 168.161 334.808 166.486 336.409 164.579L338.205 166.097C336.448 168.161 334.457 169.991 332.27 171.47Z"
        fill={`${color2}`}
      />
      <path
        d="M345.428 152.392L343.203 151.691C344.569 147.369 345.467 142.463 345.858 137.129L348.201 137.324C347.771 142.853 346.834 147.914 345.428 152.392ZM348.123 122.023L345.78 122.256C345.702 121.633 345.624 120.971 345.546 120.348C345.272 118.168 344.843 115.988 344.296 113.807C343.789 111.822 343.203 109.797 342.5 107.85L344.726 107.071C345.468 109.096 346.092 111.199 346.6 113.262C347.146 115.52 347.576 117.779 347.888 120.037C347.966 120.66 348.044 121.361 348.123 122.023ZM336.097 94.4565C333.598 90.3683 330.591 86.358 327.195 82.5034L328.952 80.946C332.427 84.8784 335.511 89.0056 338.088 93.2105L336.097 94.4565ZM262.771 88.9277C261.17 89.317 257.109 89.3949 254.493 87.8375C252.541 86.6695 250.901 84.8395 249.808 82.5813L251.916 81.569C252.853 83.4768 254.142 84.9174 255.704 85.8518C257.578 86.9809 260.936 86.9809 262.224 86.6695C262.38 86.6305 262.458 86.5916 262.458 86.5916C262.576 86.5137 262.693 86.4358 262.81 86.358L264.098 88.3047C263.981 88.3826 263.825 88.4994 263.708 88.5773C263.474 88.733 263.161 88.8498 262.771 88.9277ZM316.496 72.0688C312.748 68.9151 308.726 65.8781 304.471 63.1137L305.759 61.167C310.093 63.9703 314.193 67.0462 318.019 70.2778L316.496 72.0688ZM272.532 75.1836L270.228 74.7164C270.541 73.2758 270.697 71.7963 270.697 70.3557C270.697 68.2921 270.424 66.1896 269.916 64.0482C269.643 62.8801 269.252 61.7121 268.823 60.544L271.009 59.7264C271.478 60.9723 271.868 62.2572 272.181 63.5031C272.766 65.8003 273.04 68.1364 273.04 70.3557C273.04 71.952 272.883 73.5873 272.532 75.1836ZM251.916 67.9806L249.808 66.9683C251.916 62.5297 255.938 58.6362 260.78 56.3001L261.092 56.1444L262.107 58.2469L261.795 58.4026C257.422 60.5051 253.83 64.0092 251.916 67.9806ZM290.844 57.4682C286.588 56.1833 283.23 55.3657 281.59 55.3267C279.716 55.2489 277.998 55.2099 276.358 55.2878L276.28 52.9517C277.998 52.9127 279.755 52.9127 281.708 53.0296C284.206 53.1464 288.931 54.5091 291.547 55.2878L290.844 57.4682ZM261.248 48.0069C258.046 44.2692 254.298 41.0375 250.12 38.351L251.37 36.3653C255.743 39.1687 259.647 42.556 263.005 46.4885L261.248 48.0069Z"
        fill={`${color2}`}
      />
      <path
        d="M236.65 32.355C234.19 31.6931 231.691 31.2259 229.231 30.9534L229.466 28.6173C232.043 28.8898 234.659 29.357 237.275 30.0968L236.65 32.355Z"
        fill={`${color2}`}
      />
      <path
        d="M146.574 291.546C146.574 291.546 145.715 300.034 138.999 300.618C145.715 301.202 146.574 309.69 146.574 309.69C146.574 309.69 147.433 301.202 154.148 300.618C147.433 300.034 146.574 291.546 146.574 291.546Z"
        fill={`${color4}`}
      />
      <path
        d="M381.935 242.176C381.935 242.176 380.569 255.687 369.87 256.621C380.569 257.555 381.935 271.066 381.935 271.066C381.935 271.066 383.302 257.555 394 256.621C383.302 255.687 381.935 242.176 381.935 242.176Z"
        fill={`${color3}`}
      />
      <path
        d="M12.0648 78.8824C12.0648 78.8824 10.6982 92.3929 0 93.3274C10.6982 94.2618 12.0648 107.772 12.0648 107.772C12.0648 107.772 13.4314 94.2618 24.1296 93.3274C13.4314 92.3929 12.0648 78.8824 12.0648 78.8824Z"
        fill={`${color3}`}
      />
      <path
        d="M270.736 191.95C270.736 191.95 269.682 203.942 261.521 204.76C269.682 205.577 270.736 217.569 270.736 217.569C270.736 217.569 271.79 205.577 279.95 204.76C271.79 203.942 270.736 191.95 270.736 191.95Z"
        fill={`${color2}`}
      />
      <path
        d="M59.0747 16.8199C59.0747 16.8199 58.0204 28.8119 49.8601 29.6296C58.0204 30.4472 59.0747 42.4392 59.0747 42.4392C59.0747 42.4392 60.1289 30.4472 68.2892 29.6296C60.0898 28.8119 59.0747 16.8199 59.0747 16.8199Z"
        fill={`${color2}`}
      />
      <path
        d="M100.657 300.735C118.792 300.735 133.494 287.521 133.494 271.222C133.494 254.922 118.792 241.709 100.657 241.709C82.522 241.709 67.8206 254.922 67.8206 271.222C67.8206 287.521 82.522 300.735 100.657 300.735Z"
        fill={`${color2}`}
      />
      <path
        d="M115.494 266.355C114.791 262.5 112.136 259.385 108.115 259.113C103.039 258.763 101.048 263.318 100.696 263.746C100.462 263.474 99.4078 260.748 96.5575 259.502C91.8722 257.439 86.2497 260.631 85.586 267.406C85.2736 270.91 86.2888 273.597 88.2801 276.4C91.1694 280.41 96.1671 284.771 100.15 287.691C100.306 287.808 100.384 287.808 100.54 287.691C102.688 286.095 109.95 281.072 113.698 275.271C115.494 272.546 116.08 269.548 115.494 266.355Z"
        fill={`${color4}`}
      />
      <path
        d="M279.872 152.236C291.452 152.236 300.839 143.799 300.839 133.392C300.839 122.984 291.452 114.547 279.872 114.547C268.293 114.547 258.905 122.984 258.905 133.392C258.905 143.799 268.293 152.236 279.872 152.236Z"
        fill={`${color2}`}
      />
      <path
        d="M289.36 130.277C288.931 127.824 287.213 125.838 284.636 125.643C281.395 125.41 280.146 128.33 279.911 128.603C279.755 128.408 279.091 126.695 277.256 125.877C274.289 124.553 270.658 126.617 270.267 130.939C270.072 133.197 270.736 134.91 271.985 136.701C273.82 139.271 277.022 142.035 279.56 143.943C279.638 144.021 279.716 144.021 279.794 143.943C281.161 142.931 285.807 139.738 288.189 136C289.36 134.248 289.712 132.34 289.36 130.277Z"
        fill={`${color4}`}
      />
    </svg>
  );
}
